<template>
  <div class="home">
    <HeroComponent />
    <DividerComponent2 />
    <AboutMeComponent />
    <StackComponent />
    <div class="custom-shape-divider-top-1684860114">
      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
        style="background: rgb(234 234 234)"
      >
        <path
          d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
          class="shape-fill"
        ></path>
      </svg>
    </div>
    <ProjectsComponent />
    <DividerComponent />
    <ExperienceComponent />
    <ContactMeComponent />
  </div>
</template>

<script>
import HeroComponent from "@/components/HeroComponent.vue";
import AboutMeComponent from "@/components/AboutMeComponent.vue";
import ProjectsComponent from "@/components/ProjectsComponent.vue";
import DividerComponent from "@/components/DividerComponent.vue";
import ExperienceComponent from "@/components/ExperienceComponent.vue";
import StackComponent from "@/components/StackComponent.vue";
import DividerComponent2 from "@/components/DividerComponent2.vue";
import ContactMeComponent from "@/components/ContactMeComponent.vue";

export default {
  name: "HomeView",
  components: {
    HeroComponent,
    AboutMeComponent,
    ProjectsComponent,
    DividerComponent,
    ExperienceComponent,
    StackComponent,
    DividerComponent2,
    ContactMeComponent,
  },
};
</script>

<style>
html {
  background-image: linear-gradient(right, lightblue, darkblue);
}

.custom-shape-divider-top-1684860114 {
  width: 100%;
}

.custom-shape-divider-top-1684860114 svg {
  position: relative;
  display: block;
  width: 100%;
  height: 100px;
}

.custom-shape-divider-top-1684860114 .shape-fill {
  fill: rgb(76 155 118);
}
</style>
